import { gql } from '@apollo/client';
import type { PageRequestTypeInput } from '../../../../../graphql/queries/getBagDetail';

export const GET_BAG_SHIPMENT_SNAPSHOT = gql`
    query GetBagShipmentSnapshot(
        $bagNumber: String!
        $nodeId: String!
        $pageRequest: PageRequestTypeInput
        $inBagStatus: BagInBagStatus
        $orderStatuses: [String!]
        $trackingNumber: String
    ) {
        bagShipmentSnapshot(bagNumber: $bagNumber, nodeId: $nodeId, pageRequest: $pageRequest, inBagStatus: $inBagStatus, orderStatuses: $orderStatuses, trackingNumber: $trackingNumber) {
            nodeId
            bagNumber
            content {
                orderId
                trackingNumber
                orderStatus
                inBagStatus
                inBagAt
                outBagAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export type BagInBagStatus = 'IN_BAG' | 'OUT_OF_BAG';

export interface BagShipmentSnapshotParcelType {
    orderId: number | null;
    trackingNumber: string;
    orderStatus: string;
    inBagStatus: BagInBagStatus;
    inBagAt: string | null;
    outBagAt: string | null;
}

export interface BagShipmentSnapshotType {
    nodeId: string;
    bagNumber: string;
    content: BagShipmentSnapshotParcelType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface GetBagShipmentSnapshotResponse {
    bagShipmentSnapshot: BagShipmentSnapshotType | null;
}

export interface GetBagShipmentSnapshotVariables {
    bagNumber: string;
    nodeId: string;
    pageRequest?: PageRequestTypeInput;
    inBagStatus?: BagInBagStatus | null;
    orderStatuses?: string[] | null;
    trackingNumber?: string | null;
}
